import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Applications

const Messenger = Loader(
  lazy(() => import('src/content/applications/Messenger'))
);
const Users = Loader(lazy(() => import('src/content/Users')));
const Groups = Loader(lazy(() => import('src/content/groups')));
const Categories = Loader(lazy(() => import('src/content/Categories')));
const Versions = Loader(lazy(() => import('src/content/versions')));

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);

const routes: RouteObject[] = [
  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/messenger" />
      },

      {
        path: '*',
        element: <Status404 />
      }
    ]
  },
  {
    path: '',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="tasks" replace />
      },
      {
        path: 'messenger',
        element: <Messenger />
      },
      {
        path: 'users',
        element: <Users />
      },
      {
        path: 'groups',
        element: <Groups />
      },
      {
        path: 'categories',
        element: <Categories />
      },
      {
        path: 'versions',
        element: <Versions />
      }
    ]
  }
];

export default routes;
